import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ToneWithContext } from "../context/ToneWithContext";
import { optionsFromArguments } from "../util/Defaults";
import { Emitter } from "../util/Emitter";
import { noOp, readOnly } from "../util/Interface";
import { StateTimeline } from "../util/StateTimeline";
import { TickSource } from "./TickSource";
import { assertContextRunning } from "../util/Debug";
/**
 * A sample accurate clock which provides a callback at the given rate.
 * While the callback is not sample-accurate (it is still susceptible to
 * loose JS timing), the time passed in as the argument to the callback
 * is precise. For most applications, it is better to use Tone.Transport
 * instead of the Clock by itself since you can synchronize multiple callbacks.
 * @example
 * // the callback will be invoked approximately once a second
 * // and will print the time exactly once a second apart.
 * const clock = new Tone.Clock(time => {
 * 	console.log(time);
 * }, 1);
 * clock.start();
 * @category Core
 */

export var Clock = /*#__PURE__*/function (_ToneWithContext) {
  _inherits(Clock, _ToneWithContext);

  var _super = _createSuper(Clock);

  function Clock() {
    var _this;

    _classCallCheck(this, Clock);

    _this = _super.call(this, optionsFromArguments(Clock.getDefaults(), arguments, ["callback", "frequency"]));
    _this.name = "Clock";
    /**
     * The callback function to invoke at the scheduled tick.
     */

    _this.callback = noOp;
    /**
     * The last time the loop callback was invoked
     */

    _this._lastUpdate = 0;
    /**
     * Keep track of the playback state
     */

    _this._state = new StateTimeline("stopped");
    /**
     * Context bound reference to the _loop method
     * This is necessary to remove the event in the end.
     */

    _this._boundLoop = _this._loop.bind(_assertThisInitialized(_this));
    var options = optionsFromArguments(Clock.getDefaults(), arguments, ["callback", "frequency"]);
    _this.callback = options.callback;
    _this._tickSource = new TickSource({
      context: _this.context,
      frequency: options.frequency,
      units: options.units
    });
    _this._lastUpdate = 0;
    _this.frequency = _this._tickSource.frequency;
    readOnly(_assertThisInitialized(_this), "frequency"); // add an initial state

    _this._state.setStateAtTime("stopped", 0); // bind a callback to the worker thread


    _this.context.on("tick", _this._boundLoop);

    return _this;
  }

  _createClass(Clock, [{
    key: "state",
    get:
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */
    function get() {
      return this._state.getValueAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset  Where the tick counter starts counting from.
     */

  }, {
    key: "start",
    value: function start(time, offset) {
      // make sure the context is running
      assertContextRunning(this.context); // start the loop

      var computedTime = this.toSeconds(time);
      this.log("start", computedTime);

      if (this._state.getValueAtTime(computedTime) !== "started") {
        this._state.setStateAtTime("started", computedTime);

        this._tickSource.start(computedTime, offset);

        if (computedTime < this._lastUpdate) {
          this.emit("start", computedTime, offset);
        }
      }

      return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     * @example
     * const clock = new Tone.Clock(time => {
     * 	console.log(time);
     * }, 1);
     * clock.start();
     * // stop the clock after 10 seconds
     * clock.stop("+10");
     */

  }, {
    key: "stop",
    value: function stop(time) {
      var computedTime = this.toSeconds(time);
      this.log("stop", computedTime);

      this._state.cancel(computedTime);

      this._state.setStateAtTime("stopped", computedTime);

      this._tickSource.stop(computedTime);

      if (computedTime < this._lastUpdate) {
        this.emit("stop", computedTime);
      }

      return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */

  }, {
    key: "pause",
    value: function pause(time) {
      var computedTime = this.toSeconds(time);

      if (this._state.getValueAtTime(computedTime) === "started") {
        this._state.setStateAtTime("paused", computedTime);

        this._tickSource.pause(computedTime);

        if (computedTime < this._lastUpdate) {
          this.emit("pause", computedTime);
        }
      }

      return this;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked.
     */

  }, {
    key: "ticks",
    get: function get() {
      return Math.ceil(this.getTicksAtTime(this.now()));
    },
    set: function set(t) {
      this._tickSource.ticks = t;
    }
    /**
     * The time since ticks=0 that the Clock has been running. Accounts for tempo curves
     */

  }, {
    key: "seconds",
    get: function get() {
      return this._tickSource.seconds;
    },
    set: function set(s) {
      this._tickSource.seconds = s;
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */

  }, {
    key: "getSecondsAtTime",
    value: function getSecondsAtTime(time) {
      return this._tickSource.getSecondsAtTime(time);
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */

  }, {
    key: "setTicksAtTime",
    value: function setTicksAtTime(ticks, time) {
      this._tickSource.setTicksAtTime(ticks, time);

      return this;
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */

  }, {
    key: "getTimeOfTick",
    value: function getTimeOfTick(tick) {
      var before = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.now();
      return this._tickSource.getTimeOfTick(tick, before);
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */

  }, {
    key: "getTicksAtTime",
    value: function getTicksAtTime(time) {
      return this._tickSource.getTicksAtTime(time);
    }
    /**
     * Get the time of the next tick
     * @param  offset The tick number.
     */

  }, {
    key: "nextTickTime",
    value: function nextTickTime(offset, when) {
      var computedTime = this.toSeconds(when);
      var currentTick = this.getTicksAtTime(computedTime);
      return this._tickSource.getTimeOfTick(currentTick + offset, computedTime);
    }
    /**
     * The scheduling loop.
     */

  }, {
    key: "_loop",
    value: function _loop() {
      var _this2 = this;

      var startTime = this._lastUpdate;
      var endTime = this.now();
      this._lastUpdate = endTime;
      this.log("loop", startTime, endTime);

      if (startTime !== endTime) {
        // the state change events
        this._state.forEachBetween(startTime, endTime, function (e) {
          switch (e.state) {
            case "started":
              var offset = _this2._tickSource.getTicksAtTime(e.time);

              _this2.emit("start", e.time, offset);

              break;

            case "stopped":
              if (e.time !== 0) {
                _this2.emit("stop", e.time);
              }

              break;

            case "paused":
              _this2.emit("pause", e.time);

              break;
          }
        }); // the tick callbacks


        this._tickSource.forEachTickBetween(startTime, endTime, function (time, ticks) {
          _this2.callback(time, ticks);
        });
      }
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     * @example
     * const clock = new Tone.Clock();
     * clock.start("+0.1");
     * clock.getStateAtTime("+0.1"); // returns "started"
     */

  }, {
    key: "getStateAtTime",
    value: function getStateAtTime(time) {
      var computedTime = this.toSeconds(time);
      return this._state.getValueAtTime(computedTime);
    }
    /**
     * Clean up
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Clock.prototype), "dispose", this).call(this);

      this.context.off("tick", this._boundLoop);

      this._tickSource.dispose();

      this._state.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneWithContext.getDefaults(), {
        callback: noOp,
        frequency: 1,
        units: "hertz"
      });
    }
  }]);

  return Clock;
}(ToneWithContext);
Emitter.mixin(Clock);